module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/css-32.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/css.md
// module id = 721
// module chunks = 452